import {
  RecordStatus,
  RecordId,
  AvailableVersions,
  FileType,
} from "@/domain/records/types";

/**
 * Domain Model for Record entity
 * Clean Architecture - Domain Layer
 */
export class Record {
  constructor(
    public readonly id: RecordId,
    public readonly name: string,
    public readonly status: RecordStatus,
    public readonly availableVersions: AvailableVersions,
    public readonly sizeMb: number,
    public readonly fileExtension?: string,
    public readonly isPublic: boolean = false,
    public readonly fileType?: FileType,
    public readonly createdAt?: Date,
    public readonly updatedAt?: Date,
    public readonly participantsCount?: number
  ) {}

  /**
   * Check if record has specific report type available
   */
  hasReportType(reportType: string): boolean {
    const versions = this.availableVersions[reportType];
    return versions && versions.length > 0;
  }

  /**
   * Get latest version for specific report type
   */
  getLatestVersion(reportType: string): number | null {
    const versions = this.availableVersions[reportType];
    return versions && versions.length > 0 ? Math.max(...versions) : null;
  }

  /**
   * Get all available report types
   */
  getAvailableReportTypes(): string[] {
    return Object.keys(this.availableVersions).filter(
      (type) => this.availableVersions[type].length > 0
    );
  }

  /**
   * Check if record is in progress
   */
  get isInProgress(): boolean {
    return [
      RecordStatus.Processing,
      RecordStatus.InProgress,
      RecordStatus.Uploading,
    ].includes(this.status);
  }

  /**
   * Check if record is finished
   */
  get isFinished(): boolean {
    return this.status === RecordStatus.Finished;
  }

  /**
   * Check if record has errors
   */
  get hasError(): boolean {
    return this.status === RecordStatus.Error;
  }
}
